module.exports = __webpack_public_path__ + "img/全屏.d2340e21.png";